import React from "react";
import { Trophy, Gift, RotateCcw, TrendingUp, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { rewardPrograms } from "../../content/rewards";

const benefits = [
  { id: "monthly-leaderboard", ...rewardPrograms.leaderboard, icon: Trophy, to: "/leaderboard" },
  { id: "weekly-lossback", ...rewardPrograms.lossback, icon: RotateCcw },
  { id: "wager-rewards", ...rewardPrograms.wager, icon: TrendingUp, to: "/rewards" },
  { id: "reload-bonus", ...rewardPrograms.reload, icon: Gift },
];

export const VipBenefits = () => (
  <section className="vip-benefits" aria-label="Exclusive GreenVenom benefits" data-testid="vip-benefits">
    {benefits.map(({ id, title, icon: Icon, description, to }) => (
      <article key={id} className="vip-benefit glass" data-testid={`vip-benefit-${id}`}>
        <div className="vip-emblem" aria-hidden="true"><Icon size={28} strokeWidth={1.6} /></div>
        <div className="vip-benefit-copy">
          <h2 className="font-display text-base md:text-lg font-bold" data-testid={`vip-benefit-title-${id}`}>
            {to ? <Link to={to} className="vip-benefit-link" data-testid={`vip-${id}-link`}>{title}<ArrowUpRight size={16} aria-hidden="true" /></Link> : title}
          </h2>
          <p data-testid={`vip-benefit-description-${id}`}>{description}</p>
        </div>
      </article>
    ))}
  </section>
);